import React, { Component } from 'react';
import HomePanel from '../HomePanel';
import {withRouter} from 'react-router-dom';
import { isUserLoggedIn } from '../../service/UserService';
import {Helmet} from "react-helmet";

class ItemPage7 extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    register(id){
        if(isUserLoggedIn()){
            this.props.history.push("/termekregisztracio?termek="+id);
        }
        else{
            this.props.history.push("/regisztracio");
        }
    }
    render() { 
        return ( 
            <div className="kwizda-itempage-container">
                <Helmet>
                    <meta 
                        name="title"
                        content="Fűkomposztálás gyorsítás kísérlet"
                    />
                    <meta name="description" content="Fűkomposztálás gyorsítás kísérlet" />
                    <meta name="keywords" content="nagy termés, kötődés, terméskötődés, termés növelés, biostimulátor, foszfor, bór, alga, paradicsom, biológiai, tesztelje ingyen, regisztráció, biológiai, biológiai gazdálkodás" />
                </Helmet>
                <div className="kwizda-itempage">
                    <h2>Fűkomposztálás gyorsítás kísérlet</h2>
                    <div>
                        <br/>A kísérlet témája az egy komponensű AgriN mikrobiológiai készítmény és egy baktériumkeverék hatásának vizsgálata a fűnyesedék komposztálódási folyamataira. 
                        <br/>A kertekben legnagyobb mennyiségben képződő növényi hulladék a fűnyesedék. Ennek biológiai hasznosítása az öko-tudatos kertészek egyik legfontosabb kihívása. Az egyik cél, hogy a komposztálódás sebessége lépést tartson a fűnyírásnál folyamatosan képződő nyesedékkel. Másik pedig, hogy gyorsan már kész, ültetésre alkalmas komposzt alakuljon ki.
                        <br/>
                        <b>A kísérlet lényege, hogy nyomon követjük a komposztképződés folyamatát, ezt fotókkal dokumentáljuk, kiértékeljük és megosztjuk.</b>
                    </div>
                    <h3>Szakmai feltételek:</h3>
                    <div style={{marginTop:30}}>
                        Az „on-garden” kísérletben 1 db AgriN 100 g mikrobiológiai készítményt és 1 l  baktériumkeveréket küldünk ki a résztvevőknek.
                        <br/>A kísérlethez szükséges két egyforma belátható, legalább 1 m magas komposztáló, amelyben megfigyelhető (mérhető!) az anyag magassága. Fontos, hogy azonos legyen a benapozottság és a nedvességtartalom.
                        <br/>Annyi levágott friss fű kell, hogy egyidőben mindkét komposztálót 1 m magasan fel lehessen tölteni vele.
                        <br/>A füvet berakjuk az <b>A komposztálóba</b> és 3 szintben belocsoljuk az egyiket 20 g Agrinnal, melyet 10 liter vízben oldunk fel, a <b>B komposztálóban</b> pedig 1 liter baktériumkeverékkel, ugyancsak 10 liter vízzel hígítva.
                        <br/>A kísérlet 4 hétig tart. Július elsején kell összerakni frissen vágott fűből az 1 méter magas anyagot és azonnal belocsolni a mikrobiológiai készítményekkel. Mellé teszünk egy mérőpálcát és oldalról lefotózzuk.
                        <br/>A komposztot hetente meg kell locsolni 10-20 liter vízzel, amennyiben nem esik rá eső abban az időszakban. 
                        <br/>A kísérlet indítása után 30 nappal kibontjuk a komposztálót, kilapátoljuk az anyagot egy-egy kupacba és lefotózzuk.
                        <br/>A kísérlet akkor minősül sikeresnek, ha minden kezelést és fotózást a kért módon elvégeztek.
                        <br/>A kísérlet meghiúsulása esetén nem küldünk a leírásban szereplő ajándékot.
                        <br/>Az utolsó fotó után megy az ajándék.
                    </div>
                    <h3>Dokumentációs feltételek:</h3>
                    <div style={{marginTop:30}}>
                        Az első kezeléstől a következő időszakonként kérünk dokumentáló fotókat.
                        <br/>
                        <br/><b>1. két fotó:</b> Kiindulási állapot. 
                        <br/>&nbsp;&nbsp;Az A komposztáló oldalról, úgy hogy mellettük jól látható legyen a mérőpálca cm-es osztással
                        <br/>&nbsp;&nbsp;A B komposztáló oldalról, úgy hogy mellettük jól látható legyen a mérőpálca cm-es osztással
                        <br/>
                        <br/><b>2. két fotó:</b> 1 héttel később ugyanabban a szögben és távolságról 
                        <br/>&nbsp;&nbsp;Az A komposztáló oldalról, úgy hogy mellettük jól látható legyen a mérőpálca cm-es osztással
                        <br/>&nbsp;&nbsp;A B komposztáló oldalról, úgy hogy mellettük jól látható legyen a mérőpálca cm-es osztással
                        <br/>
                        <br/><b>3.két fotó:</b> 1 héttel később ugyanabban a szögben és távolságról 
                        <br/>&nbsp;&nbsp;Az A komposztáló oldalról, úgy hogy mellettük jól látható legyen a mérőpálca cm-es osztással
                        <br/>&nbsp;&nbsp;A B komposztáló oldalról, úgy hogy mellettük jól látható legyen a mérőpálca cm-es osztással
                        <br/>
                        <br/><b>4.két fotó:</b> 1 héttel később ugyanabban a szögben és távolságról 
                        <br/>&nbsp;&nbsp;Az A komposztáló oldalról, úgy hogy mellettük jól látható legyen a mérőpálca cm-es osztással
                        <br/>&nbsp;&nbsp;A B komposztáló oldalról, úgy hogy mellettük jól látható legyen a mérőpálca cm-es osztással
                        <br/>
                        <br/>Utána ki kell bontani és ki kell lapátolni a komposztot mindkettőből egy-egy külön kupacba, egymás mellé közvetlenül. 
                        <br/><b>5.fotó</b> egy közös fotó a kép kupacról, úgy, hogy mindkét kupac rajta legyen. Végül egyenként egy közeli képet a kész komposztról, amelyen látható az állaguk.
                        <br/>
                        <br/>A fotókat minden héten hétfőn reggel 8-ig kérjük emailben megküldeni a <a className='kwizda3-link' href='mailto:marketing@muchmore.hu'>marketing@muchmore.hu</a> email címre.

                        <div style={{marginTop:30}}>
                            <img alt="cimke" style={{display:'inline-block', width:'25%'}} src="img/kwizda3_cimkek/nezzuk_kiserletek_thumbnail_web_fukomposzt.png"></img>
                            <img alt="kepseged" style={{display:'inline-block', width:'75%'}} src="img/kwizda3_fotoseged/web_komposzt_kepseged.png"></img>
                        </div>
                    </div>
                    <h3>Nevezési feltételek:</h3>
                    <div>
                        Regisztráció a nezzukbioban.hu oldalon
                        <br/><b>Itt meg kell adni az elérhetőséget és a kísérlet helyét.</b>
                        <br/><b>Kérünk fotót a leanderekről és közvetlen környezetükről.</b>
                        <br/>A jelentkezők közül 4 kertészt választunk ki. A döntésnél a kísérletben szereplő leanderek méretét, állapotát és a beszóródás elleni védelem megoldhatóságát vesszük figyelembe.
                        <br/>
                        <br/><b>A kiválasztott kertészeket emailben értesítjük.</b>
                        <br/>
                        <br/><b>Garantált nyeremény egy sikeresen dokumentált kísérlet után:</b>
                        <ul>
                            <li>1 db Biopázsit 3 in 1 mikrobiológiai terméktrió</li>
                        </ul>
                        <br/>A kísérlet akkor értékelhető sikeresnek, ha a kezelések megtörténtek, beazonosíthatók a növények és minden héten megkapjuk a kért minőségű fotókat.
                        <br/>Ebben az esetben az ajándékokat a kísérlet befejeződése utáni két héten belül postán küldjük meg a résztvevőknek a regisztráció során megadott címre.
                        <br/>
                        <br/><b>Tartson velünk! </b>
                        <br/><b>Nézzük együtt milyen hatással vannak a virágzásra és hajtásfejlődésre a baktériumkeverékek és a specializált, egykomponensű AMAZON baktériumkészítményünk!</b>
                    </div>
                    <br/>
                    <div className="kwizda-itempage-table-div">
                            <table className="kwizda-itempage-table">
                                <thead>
                                    <tr>
                                        <th>Nevezési határidő:</th>
                                        <th>Kísérlet megvalósítás időzítése: </th>
                                        <th>Megvalósítás helye: </th>
                                        <th>Helyszínek száma:</th>
                                        <th>Dokumentáció módja:</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>2025. 04. 15.</td>
                                        <td>2025 05-06 között</td>
                                        <td>Dézsás növényeken, szabadban</td>
                                        <td>Maximum 4 helyszínen</td>
                                        <td>Fotó és adatok küldése emailcímre</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                </div>
                <br/>
                <HomePanel isItemPage={true} register={()=>this.register(7)}></HomePanel>
            </div>
         );
    }
}

export default withRouter(ItemPage7);